<template>

<v-app-bar
      app
      absolute
      dark
      color="#393E46"
    >

      <v-toolbar-title>
        <router-link :to="{ name: 'homepage'}">
        <v-img
          alt="Tunay Logo"
          class="shrink mt-1  hidden-sm-only hidden-xs-only"
          contain
          min-width="100"
          src="@/assets/tunaywhitelogo.png"
          width="100"
        /></router-link>

        <router-link :to="{ name: 'homepage'}">
          <v-img
              alt="Tunay Logo"
              class="shrink mt-1  hidden-md-only hidden-lg-only hidden-xl-only"
              contain
              min-width="50"
              src="@/assets/tunaylogo.png"
              width="50"
          /></router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>




    </v-app-bar>

    </template>
<script>


  export default {
    name: 'cabecerados',
    components: {

    },
    data: () => ({
    links: [
      {'url':'Contactenos', 'href':'#contact' },
    ],
  }),
  }
</script>
